import { Plus, SlidersHorizontal } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import type { ContentPanelHeaderProps } from '@/types/category';

import { Button } from '@/components/ui/button';

export function ContentPanelHeader({ onAddMessage, onAddCategory }: ContentPanelHeaderProps) {
  const { t } = useTranslation();

  return (
    <div className="flex w-[98%] items-center justify-between gap-4 pb-5">
      <span className="flex flex-col">
        <span className="text-xl font-medium">
          {t('common:configuration.predefinedMessages.title')}
        </span>
        <span className="text-muted-foreground mt-1 text-sm">
          {t('common:configuration.predefinedMessages.subtitle')}
        </span>
      </span>
      <span className="flex items-center gap-2">
        <Button type="button" variant="outline" className="gap-2" onClick={onAddCategory}>
          <SlidersHorizontal className="h-4 w-4" />
          {t('common:configuration.predefinedMessages.addCategory')}
        </Button>
        <Button type="button" className="gap-2" onClick={onAddMessage}>
          <Plus className="h-4 w-4" />
          {t('common:configuration.predefinedMessages.addMessage')}
        </Button>
      </span>
    </div>
  );
}
